import { render, staticRenderFns } from "./ProductComparisonTable.vue?vue&type=template&id=62365ad5&"
import script from "./ProductComparisonTable.vue?vue&type=script&lang=js&"
export * from "./ProductComparisonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports